import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isOnboarding } from "./config";
const ProtectedRoute = ({
  component: Component,
  restricted,
  auth,
  ...rest
}) => {
  let onboarded = isOnboarding()
  if (localStorage.getItem("accessToken") && onboarded) {
    return <Outlet />;
  } else {
    return <Navigate to="/login" />;
  }
};

export default ProtectedRoute;
